import { gql } from "@apollo/client";

const GET_CHATBOT_ANALYTICS = gql`
  query GetChatbotAnalytics($botId: String, $agentId: Int, $timeFrame: String) {
    getChatbotAnalytics(
      botId: $botId
      agentId: $agentId
      timeFrame: $timeFrame
    ) {
      activeWidgets
      botConversions
      handoffs
      widgetCustomers
      avgConfidenceScore
    }
  }
`;

export default GET_CHATBOT_ANALYTICS;
